'use client'
import { Typography } from 'components/Contentful'
import { useMemoizedContentGetter } from 'utils/contentful'
import Section from 'components/Section'
import classNames from 'classnames'
import { SITE_ENVIRONMENTS } from 'constants/websites'
import { FdrTheme } from '@achieve/ascend'

function PageTitle({ content }) {
  const { title, description } = useMemoizedContentGetter(content, ['title', 'description'])
  const isFdr = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT === SITE_ENVIRONMENTS.FDR

  return (
    <Section
      className={classNames('m-0 px-0 py-8 lg:m-0 lg:px-0 lg:py-16', {
        'text-center mt-15! lg:pt-4! lg:pb-16': isFdr,
      })}
      data-testid="policies-hero-section"
    >
      <Typography
        content={title.textContent}
        className={classNames({
          [`text-[${FdrTheme.palette.primary.main}] displayLg lg:displayLg font-normal!`]: isFdr,
          'displayLg lg:displayXl': !isFdr,
        })}
      />
      {description && (
        <Typography
          content={description.textContent}
          className={classNames({
            'text-gray-500 bodySm lg:bodySm': isFdr,
            'bodySm lg:bodySm': !isFdr,
          })}
        />
      )}
    </Section>
  )
}
export { PageTitle }
export default PageTitle
